// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestInstrumentSecurityControlService: () => UseMutationResult<
  void,
  string,
  {
    operator: string;
    instrumentSecurityControl: string;
    upgrader: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryInstrumentSecurityControlService', ledgerApi, party],
    mutationFn: async ({ operator, instrumentSecurityControl, upgrader }) => {
      return ledgerApi.requestRegistryInstrumentSecurityControlService(
        operator,
        instrumentSecurityControl,
        upgrader,
      );
    },
    retry: false,
  });
};

export default useRequestInstrumentSecurityControlService;
